import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import createLogger from 'src/utils/logger';
import debounce from 'lodash/debounce';
import uniq from 'lodash/uniq';
import { User, Project } from 'src/api';
import { SUGGESTED_SKILLS } from 'src/constants/suggestions';
import { AutoSuggestInput } from 'src/components/Common';
import AddImages from './AddImages';

import './AddProject.scss';

const DeletableItem = (props) => {
  return (
    <div className="dynamic--item">
      <div className="text">{props.text}</div>
      <div className='btn-delete' onClick={() => props.onDelete(props.text)}>X</div>
    </div>
  )
}
DeletableItem.propTypes = {
  text: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
}


class AddProjectModal extends Component {
  constructor() {
    super();
    this.inputTechRef = React.createRef();
    this.regEx = new RegExp('^[a-zA-Z0-9].*');
    this.logger = createLogger('AddProjectModal');
    this.state = {
      newProject: true,
      projectId: '', // Defined only when we're editing that project
      name: '',
      hackathon: '',
      hackathonError: '',
      team: '',
      teamMembers: [],
      notValidUsers: [],
      idea_descr: '',
      project_descr: '',
      images: [],
      imagesError: [],
      technologies: [],
      links: [],
    };

    this.debounceOnTeamChange = debounce(this.checkUsers, 500);
  }

  componentDidMount() {
    const projectId = this.props.match.params.projectId;
    if (projectId !== undefined) {
      this.setState({
        newProject: false,
        projectId,
      })
      this.setProject(projectId);
    }
  }

  setProject = (projectId) => {
    Project.getProjectById(projectId)
      .then((res) => {
        this.setState({
            ...res.data,
            team: res.data.team.reduce((acc, cur) => (acc ? ',' : '') + cur.username, ''),
          }, () => this.checkUsers(this.state.team)
        );
      });
  }

  closePage = () => {
    this.props.history.push('/account', { tab: 'projects' });
  }

  addProjectLink = (newLink) => {
    return new Promise((res, rej) => {
      if (!newLink) {
        rej('Нельзя добавить пустой линк.');
        return;
      }
      if (this.state.links.indexOf(newLink) !== -1) {
        rej('Такой линк уже добавлен!');
        return;
      }
      this.setState((state) => ({
        links: [...state.links, newLink],
      }));
      res();
    })
  }

  deleteProjectLink = (link) => {
    this.setState((state) => {
      const linkPosition = state.links.indexOf(link);
      state.links.splice(linkPosition, 1);
      return {
        links: state.links,
      }
    });
  }

  addTechnology = (newTech) => {
    return new Promise((res, rej) => {
      if (!newTech) {
        rej('Нельзя добавить пустую технологию.');
        return;
      }
      if (this.state.technologies.indexOf(newTech) !== -1) {
        rej('Такая технология уже добавлена!');
        return;
      }
      this.setState((state) => ({
        technologies: [...state.technologies, newTech],
      }));
      res();
    })
  }

  deleteUsedTech = (tech) => {
    this.setState((state) => {
      const linkPosition = state.technologies.indexOf(tech);
      state.technologies.splice(linkPosition, 1);
      return {
        technologies: state.technologies,
      }
    });
  }

  getTechSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0 ? [] : SUGGESTED_SKILLS.filter((tech) => {
      return tech.toLowerCase().slice(0, inputLength) === inputValue;
    });
  }

  onInputChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
      [[e.target.id] + 'Error']: false,
    })
  }

  updateNonValidUsers = (teamMembers, notValidUsers) => {
    this.setState({ teamMembers, notValidUsers });
  }

  onTeamChange = (e) => {
    const team = e.target.value;
    this.setState({ team, teamError: false });
    this.debounceOnTeamChange(team);
  }

  checkUsers = (team) => {
    const users = [];
    uniq(
      team.split(',').map(user => user = user.trim())
    )
    .forEach(user => {
      // Checking if starts with "."
      if (user && this.regEx.test(user)) {
        users.push(user);
      }
    });
    Promise.all(users.map(user => User.checkUserName(user).catch(() => false)))
      .then((res) => {
        const notValidUsers = res.map((r, i) => !r && users[i]).filter(r => r !== false);
        this.updateNonValidUsers(users, notValidUsers);
      });
  }

  getTeamMembersIds = () => {
    return Promise.all(this.state.teamMembers.map((teamMember) => User.getUserIdByName(teamMember)))
      .then((teamMembersData) => {
        this.logger.info('getTeamMembersIds()', teamMembersData);
        return teamMembersData.map((tmd) => tmd.id)
      });
  }

  createSubmitionForm = (teamMembersIds) => {
    // const projectForm = new FormData();
    // projectForm.append('name', this.state.name);
    // projectForm.append('hackathon', this.state.hackathon);
    // projectForm.append('team', teamMembersIds);
    // projectForm.append('table', '0');
    // projectForm.append('idea_descr', this.state.idea_descr);
    // projectForm.append('project_descr', this.state.project_descr);
    // this.state.technologies.forEach((tech) => {
    //   projectForm.append('technologies[]', tech);
    // });
    // this.state.links.forEach((link) => {
    //   projectForm.append('links[]', link);
    // });
    // this.state.images.forEach((image) => {
    //   projectForm.append('images[]', image);
    // });
    
    const projectForm = { 
      name: this.state.name,
      hackathon: this.state.hackathon,
      team: teamMembersIds,
      table: '0', // TODO: no ideas what the heck is it
      idea_descr: this.state.idea_descr,
      project_descr: this.state.project_descr,
      technologies: this.state.technologies,
      links: this.state.links,
      images: this.state.images,
    };

    return projectForm;
  }

  onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.logger.info('onSubmit()', this.state);
    this.getTeamMembersIds()
      .then((teamMembersIds) => {
        const projectForm = this.createSubmitionForm(teamMembersIds);
        if (this.state.newProject) {
          return this.createNewProject(projectForm);
        }
        return this.updateProject(projectForm);
      })
      .catch((err) => this.logger.error('Something went wrong:', err));
  }

  createNewProject = (projectForm) => {
    this.logger.info('createNewProject()', projectForm);
    return Project.createProject(projectForm)
      .then((res) => {
        this.logger.info('createNewProject() success!', res);
        toast.success(`Успешно создан проект: ${this.state.name}`);
        this.closePage();
      })
      .catch(this.onSubmitError);
  }

  updateProject = (projectForm) => {
    this.logger.info('updateProject()', this.state.projectId, projectForm);
    return Project.updateProject(this.state.projectId, projectForm)
      .then((res) => {
        this.logger.info('updateProject() success!', res);
        toast.success(`Успешно обновлен проект: ${this.state.name}`);
      })
      .catch(this.onSubmitError);
  }

  onSubmitError = (error) => {
    const errFields = error.response.data;
    this.logger.error('onSubmitError() error:', errFields);
    this.setState(() => {
      const errorState = {};
      Object.keys(errFields).forEach((err) => {
        errorState[err + 'Error'] = errFields[err];
      })
      return { ...errorState };
    });
    const errorMsg = (
      <div>
        <h3>Was not able to save:</h3>
        {Object.keys(errFields).map((err) => <div key={errFields[err]}>{err}: {errFields[err]}</div>)}
      </div>
    );
    
    toast.error(errorMsg);
  }
  
  closePage = (e) => {
    this.props.history.push(`/account`, { tabName: 'projects' });
  }

  getErrorsHint = (errors) => {
    return errors.map((error) => {
      return (<span key={error}>{error}</span>)
    })
  }

  onUploadImages = (images) => {
    this.logger.info('onUploadImages():', images);
    this.setState({
      images: [...this.state.images, ...images],
      imagesError: [],
    });
  }

  onUploadImagesError = (imagesError) => {
    this.logger.info('onUploadImagesError():', imagesError);
    this.setState({
      imagesError,
    })
  }

  onImgDeleteByIndex = (imgIndex) => {
    this.logger.info('onImgDeleteByIndex()', imgIndex);
    if (isNaN(imgIndex) || imgIndex > this.state.images.lenght || 0 > imgIndex) {
      this.logger.info('onImgDeleteByIndex() could not delete.');
      return;
    }
    this.setState((state) => ({
      images: [...state.images.slice(0, imgIndex), ...state.images.slice(imgIndex + 1, state.images.length)],
    }));
  }

  render() {
    const { images, technologies, links } = this.state;
    const projectsElements = links.map((el) => {
      return (
        <DeletableItem key={el} text={el} onDelete={this.deleteProjectLink} />
      )
    });
    const technologiesElements = technologies.map((el) => {
      return (
        <DeletableItem key={el} text={el} onDelete={this.deleteUsedTech} />
      )
    });
    return (
      <div className='add-project'>
        <h1 className="add-project--header">Добавить проект</h1>

        <AddImages
          images={images}
          maxSize={3000000}
          onDeleteImgByIndex={this.onImgDeleteByIndex}
          onUpload={this.onUploadImages}
          onError={this.onUploadImagesError}
          errors={this.state.imagesError}
        />
        <div className="add-project--block add-project--collumn">
          <label className="label-text" htmlFor="name">Название проекта</label>
          <input type="text" id='name' placeholder='Название проекта'
            className={`block--input ${this.state.nameError ? 'input-error' : ''}`}
            value={this.state.name} onChange={this.onInputChange}
          />
        </div>
        <div className="add-project--block add-project--collumn">
          <label className="label-text" htmlFor="hackathon">Хакатон</label>
          <input type="text" id='hackathon' placeholder='Название хакатона' 
            className={`block--input ${this.state.hackatonError ? 'input-error' : ''}`}
            value={this.state.hackathon} onChange={this.onInputChange}
          />
        </div>
        <div className="add-project--block add-project--collumn">
          <label className="label-text" htmlFor="team">Команда</label>
          <input
            id="team"
            className={`block--input team-input ${this.state.notValidUsers.length || this.state.teamError ? 'input-error' : ''}`}
            placeholder="Тиммейты через запятую"
            value={this.state.team} onChange={this.onTeamChange}
          />
          {!!this.state.notValidUsers.length &&
              <div className="errors-hints">
                Not valid users: 
                {this.getErrorsHint(this.state.notValidUsers) }
              </div>
            }
        </div>
        <div className="add-project--block add-project--collumn">
          <label className="label-text" htmlFor="idea_descr">Идея проекта</label>
          <textarea name="project-idea" id="idea_descr" placeholder='Небольшое описание'
            className={`block--input block--textarea ${this.state.idea_descrError ? 'input-error' : ''}`}
            value={this.state.idea_descr} onChange={this.onInputChange}
          ></textarea>
        </div>
        <div className="add-project--block add-project--collumn">
          <label className="label-text" htmlFor="project_descr">Техническая реализация</label>
          <textarea type="text" id='project_descr' placeholder='Как проект был реализован'
            className={`block--input block--textarea ${this.state.project_descrError ? 'input-error' : ''}`}
            value={this.state.project_descr} onChange={this.onInputChange}
          ></textarea>
        </div>
        <div className="add-project--block add-project--row">
          <div className="techs-list">
            <h3 className="label-text">Технологии</h3>
            { technologiesElements }
            <AutoSuggestInput 
              getSuggestions={this.getTechSuggestions}
              addEntity={this.addTechnology} />
          </div>
          <div className="links-list">
            <h3 className="label-text" >ссылки, в том числе на диплом</h3>
            { projectsElements }
            <AutoSuggestInput addEntity={this.addProjectLink} />
          </div>
        </div>
         
        <div className="add-project--row add-project-btns">
          <button className="btn btn_black" onClick={this.onSubmit}
            disabled={this.state.sendingRequest || this.state.notValidUsers.length}>{this.state.newProject ? 'Добавить' : 'Сохранить'}</button>
          <button className="btn btn_cancel" onClick={this.closePage}>Отменить</button>
        </div>
      </div>
    )
  }
}

AddProjectModal.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      projectId: PropTypes.string,
    }),
  }),
};

export default withRouter(AddProjectModal);





// WEBPACK FOOTER //
// ./src/components/AddProject/index.js